import { render, staticRenderFns } from "./DarcheiTorah.vue?vue&type=template&id=fac19d50&"
import script from "./DarcheiTorah.vue?vue&type=script&lang=js&"
export * from "./DarcheiTorah.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports